import { mapGetters, mapActions } from 'vuex'
import { getMasterDataText } from '../../helpers'

export default {
  computed: {
    ...mapGetters({
      table_number: 'getPosSelectedTableNumber', // selected table_number
      getTableById: 'getPosTableById', // table info
      tables: 'getPosTables',
      posSettings: 'getPosSetting',
    }),
    tableInfo () {
      return this.getTableById(this.table_number)
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
    ]),
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/tableButton.js